import styled from 'styled-components';

export const heading4 = (theme: any) => `
  font-size: ${theme.uptimeFontSizes.mobile.fz6}px;
  line-height: ${theme.uptimeLineHeights.mobile.lh6}px;
  font-weight: normal;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh8}px;
  }
`;
export const buttonLink = (theme: any) => `
  font-size: ${theme.uptimeFontSizes.mobile.fz4}px;
  line-height: ${theme.uptimeLineHeights.mobile.lh4}px;
  font-weight: normal;
    @media (min-width: 960px) {
      font-size:  ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height:  ${theme.uptimeLineHeights.desktop.lh4}px;
    }
`;

export const StyledTicketDetail = styled.div`
  ${({ theme }) => `
      position: relative;
      min-height: 300px;
      .link-tracking {
        ${buttonLink(theme)}
        text-decoration: none;
        color: ${theme.uptimeColors.mainTheme.primary};
        font-weight: 700;
      }
      .isLoadingTicketDetail {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 10;
        margin: -${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} -${theme.uptimeSpace[10]}px;
        color: ${theme.uptimeColors.generalColors.icon.enabled};
      }
      p {
        margin: ${theme.uptimeSpace[0]};
      }
      .pr-20 {
        padding-right: ${theme.uptimeSpace[10]}px;
      }
      .title-ticket {
        margin: ${theme.uptimeSpace[0]};
        padding-right: ${theme.uptimeSpace[20]}px;
        ${heading4(theme)}
        font-weight: 700;
        color: ${theme.uptimeColors.grayScales.black};
      }
      .ttl-bold {
        font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
        margin-top: ${theme.uptimeSpace[7]}px;
        display: block;
        font-weight: 700;
        color: ${theme.uptimeColors.grayScales.black};
      }
      .value {
        display: block;
        margin-top: ${theme.uptimeSpace[2]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
        color: ${theme.uptimeColors.grayScales.black};
        &.state {
          font-weight: 700;
          text-transform: uppercase;
        }
        &.Closed {
          color: ${theme.uptimeColors.grayScales.darkerGray};
        }
        &.Active,
        &.Open,
        &.awaiting_approval,
        &.under_investigation {
          color: ${theme.uptimeColors.generalColors.state.success.light};
        }
      }
      .button-default-1 {
        margin: ${theme.uptimeSpace[7]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]};
        border-radius: 5px;
      }
      .unable-cancel{
        display: grid;
        gap: 8px;
        grid-template-columns: auto auto auto;
        padding: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[4]}px;
        margin-top: ${theme.uptimeSpace[10]}px;
        align-items: flex-start;
        background-color: ${theme.uptimeColors.grayScales.grayishBackground};
        color: ${theme.uptimeColors.grayScales.black};
        .unable-cancel-message{
          font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
        }
        .unable-cancel-icon{
          font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        }
      }
      .desc-ticket {
        margin: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]};
        padding-bottom: ${theme.uptimeSpace[10]}px;
        border-top: solid 1px ${theme.uptimeColors.grayScales.black};
        border-bottom: solid 1px ${theme.uptimeColors.grayScales.black};
        .ttl-col-desc,
        .value-info {
          font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
          color: ${theme.uptimeColors.grayScales.darkerGray};
          line-height: 1.5;
          word-break: break-word;
          white-space: break-spaces;
          strong{
            color: ${theme.uptimeColors.grayScales.black};
            opacity: 0.7;
          }
          &.value-comment {
            white-space: pre-wrap;
          }
        }
        .ttl-col-desc {
          margin-top: ${theme.uptimeSpace[10]}px;
          color: ${theme.uptimeColors.grayScales.black};
          font-weight: 700;
        }
        .value-capitalize {
          text-transform: capitalize;
        }
        .closure-reason {
          margin-top: ${theme.uptimeSpace[10]}px;
          border-top: solid 1px ${theme.uptimeColors.grayScales.black};
          .value-info {
            background-color: ${theme.uptimeColors.grayScales.grayishBackground};
            padding: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[4]}px;
            max-height: 48px;
            overflow: auto;
          }
        }
      }
  `}
`;
